/**
 * Loop through the entire data array and combine values
 * @param {Array} data array of objects
 * @return {object} combined values.
 */
export const formatData = data => {
  return data.reduce(
    (acc, item) => {
      //Sum resultsByDate
      item.resultsByDate.nodes.forEach(({ date, amount }) => {
        acc.resultsByDate[date]
          ? (acc.resultsByDate[date] += amount)
          : (acc.resultsByDate[date] = amount)
      })
      //Sum totalMailed
      acc.totalMailed += item.totalMailed
      //Sum totalMailedPercent
      acc.totalMailedPercent += item.totalMailedPercent
      //Sum totalMailedPercent
      acc.totalEstimated += item.totalEstimated
      //Sum totalEstimatedPercent
      acc.totalEstimatedPercent += item.totalEstimatedPercent / data.length

      return acc
    },
    {
      resultsByDate: {},
      totalMailed: 0,
      totalMailedPercent: 0,
      totalEstimated: 0,
      totalEstimatedPercent: 0,
    },
  )
}

/**
 * Get average, median, standardDeviation
 * @param {Array} values array of numbers
 * @param {Boolean} usePopulation mode
 * @return {Object} of calculated results
 */
export const getStats = (values, usePopulation = false) => {
  //Average
  const average = values.reduce((acc, item) => acc + item, 0) / values.length

  //Median
  const sortedValues = [...values].sort(function(a, b) {
    return a - b
  })
  const mid = sortedValues.length / 2
  const median =
    mid % 1
      ? sortedValues[mid - 0.5]
      : (sortedValues[mid - 1] + sortedValues[mid]) / 2

  return { average, median }
}

export const renderMailSpeedGraphPopup = ({
  date,
  delivered,
  totalMailedPercent,
}) => `
          <table>
            <tr><td
             style="text-align: center; color: #7C7C7C; padding-bottom: 11px;">${date}</td></tr> 
            <tr><td style="text-align: center; color: #7C7C7C;  border-top: 0.25px solid #B4B4B4; padding: 7px 58px 2px">Delivered - ${delivered}</td></tr> 
            <tr><td style="text-align: center; color: #7C7C7C;">${totalMailedPercent}%</td></tr> 
          </table>
  `
/**
 * Format number to commas
 * @param {Number} num
 * @return {String} formated to 100,000,000,000
 */
export const formatNumberToCommas = num =>
  num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
